import { Box, CircularProgress, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import DataTable from 'widgets/datagrid/DataTable';

const TablaVinculation = ({
  loading,
  hasSearched,
  mappedRows,
  Columns,
  page,
  size,
  pagination,
  handleRowClick,
  getBackgroundColor,
}) => {
  return (
    <Grid>
      {loading && hasSearched ? (
        <Box
          sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '30vh' }}
        >
          <CircularProgress />
        </Box>
      ) : mappedRows?.length > 0 ? (
        <Grid paddingRight={5} paddingLeft={0}>
          <Box sx={{ height: '67vh' }}>
            <DataTable
              rows={mappedRows}
              columns={Columns}
              onRowClick={handleRowClick}
              page={page}
              pageSize={size}
              rowCount={pagination?.total_rows ?? 0}
              onPageChange={pagination?.handleChangePage}
              handleChangePageSize={pagination?.handleChangePageSize}
              getBackgroundColor={getBackgroundColor}
              loading={loading}
            />
          </Box>
        </Grid>
      ) : (
        hasSearched &&
        !loading && <Typography variant='h6'>No hay registros disponibles</Typography>
      )}
    </Grid>
  );
};

export default TablaVinculation;
